import { api } from "../lib";
import type { Patient, SexType } from "./cases.service";

export interface CreatePatientDto {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  sex: SexType;
  medicalRecordNumber?: string;
  mobilePhone?: string;
  homePhone?: string;
  workPhone?: string;
  email?: string;
  address?: Record<string, any>;
}

export type UpdatePatientDto = Partial<CreatePatientDto>;

export const patientsService = {
  getAll: async (): Promise<Patient[]> => {
    return api.get<Patient[]>("/patients");
  },

  search: async (query: string): Promise<Patient[]> => {
    return api.get<Patient[]>(
      `/patients/search?q=${encodeURIComponent(query)}`
    );
  },

  getById: async (id: string): Promise<Patient> => {
    return api.get<Patient>(`/patients/${id}`);
  },

  getByMrn: async (mrn: string): Promise<Patient | null> => {
    return api.get<Patient | null>(`/patients/by-mrn/${mrn}`);
  },

  create: async (data: CreatePatientDto): Promise<Patient> => {
    return api.post<Patient>("/patients", data);
  },

  update: async (id: string, data: UpdatePatientDto): Promise<Patient> => {
    return api.put<Patient>(`/patients/${id}`, data);
  },

  delete: async (id: string): Promise<void> => {
    return api.delete<void>(`/patients/${id}`);
  },
};

// Re-export types
export type { Patient, SexType };
